import { CommonModule } from '@angular/common';
import { Component, computed, model, OnInit, signal } from '@angular/core';
import { SelectGroupWrapperComponent } from '../select-group-wrapper/select-group-wrapper.component';
import { SelectGroupItem } from '../select-group.component';
import { ModalContainer } from '../../../modal/modal-container/modal-container.component';
import { ModalHeader } from '../../../modal/modal-header.component';
import { Input } from '../../../input/input.component';
import { Button } from '../../../button/button.component';
import { ModalAdapter } from '../../../modal/modal.adapter';
import { SelectHelper } from '../../select.hepler';

export type SelectGroupModalProps = {
  /**
   * 모달 제목
   */
  label: string;

  /**
   * 그룹화된 옵션 배열
   */
  groupArray: SelectGroupItem[];

  /**
   * 초기값 설정
   */
  initialValue?: string[] | string;

  /**
   * 라벨 바인딩
   */
  bindLabel: string;

  /**
   * 값 바인딩
   */
  bindValue: string;
};

@Component({
  selector: 'app-select-group',
  templateUrl: './select-group.modal.html',
  imports: [
    ModalContainer,
    ModalHeader,
    CommonModule,
    Input,
    Button,
    SelectGroupWrapperComponent,
  ],
})
export class SelectGroupModal
  extends ModalAdapter<SelectGroupModalProps>
  implements OnInit
{
  selectHelper = SelectHelper;
  label = computed(() => this.props()?.label);
  groupArray = computed(() => this.props()?.groupArray);
  bindLabel = computed(() => this.props()?.bindLabel);
  bindValue = computed(() => this.props()?.bindValue);
  initialValue = computed(() => this.props()?.initialValue || []);

  values = signal<string[] | string>([]);
  selecteds = computed(() => {
    const array = this.groupArray()
      ?.map((group) =>
        group.options.filter((option) =>
          this.values().includes(
            SelectHelper.get(option, this.bindValue() || ''),
          ),
        ),
      )
      .flat();

    return Array.from(new Set(array));
  });
  query = model<string>('');

  currentGroupArray = computed(() => {
    if (!this.query()) {
      return this.groupArray();
    }

    return this.groupArray()?.map((group) => {
      return {
        ...group,
        options: group.options.filter((option) => {
          return SelectHelper.get(option, this.bindLabel() || '')
            .toLowerCase()
            .includes(this.query().toLowerCase());
        }),
      };
    });
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.values.set(this.initialValue());
  }

  handleChange(ev: string[] | string) {
    this.values.set(ev);
  }

  apply() {
    this.modalService.close(this.values());
  }
}
